module.exports = __webpack_public_path__ + "static/2026_kyleKnaggsResume-7e51fd9c6be3cc5aef2b75496a98f328.pdf";